import { WarningTriangle as Warning } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from '../Icon.types';

const WarningTriangle: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <Warning width={size} height={size} color={color} {...rest} />;

export default WarningTriangle;
